import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom'

import T from '../translate/T'
import Topbar from '../components/organisms/Topbar'

import Search from '../components/container/Search'
import AsyncComponent from '../components/atoms/AsyncComponent'


const Home = AsyncComponent(() => import("./home"))
const Login = AsyncComponent(() => import("./login"))
const Signup = AsyncComponent(() => import("./signup"))
const RecoverPassword = AsyncComponent(() => import("./recoverPassword"))
const Events = AsyncComponent(() => import("./event"))
const EventInscription = AsyncComponent(() => import("./eventInscription"))
const NotFound = AsyncComponent(() => import("./404"))
const Explore = AsyncComponent(() => import("./explore"))
const Authorize = AsyncComponent(() => import("./authorize"))

class App extends Component {
  static scroll = true

  componentWillMount() {
    this.body = document.body || document.documentElement

    T.handleUpdate(() => {
      this.scroll = false
      this.forceUpdate()
      this.scroll = true
    })
  }

  render() {
    if(this.scroll) {
      window.scrollTo(0, 0)
      this.body.style.overflowY = 'auto'
    }

    return (

      <div>
        <Topbar />
        <main>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/login/:type?" component={Login} />
            <Route path="/signup/:type?" component={Signup} />
            <Route path="/password/recover/:code" component={RecoverPassword} />
            <Route exact path="/(event|experience)/:token" component={Events} />
            <Route exact path="/(event|experience)/:token/extras" component={Events} />
            <Route exact path="/(event|experience)/inscription/:token" component={EventInscription} />
            {/* <Route path="/experience/:token" component={Events} />
            <Route exact path="/experience/inscription/:token" component={EventInscription} /> */}
            <Route exact path="/explore" component={Explore} />
            <Route exact path="/search" component={Search} />
            <Route exact path="/app/authorize" component={Authorize} />

            <Route exact path="/panel/:token" render={ props => {
                if( props.match.params.token )
                    window.location.href = `${window.URL_DASH_HOME}${props.match.params.token}`
                return <div />
            }} />

            <Route exact path="/:username" render={ props => {
                if( props.match.params.username )
                    window.location.href = `https://sprinta.com.br/${props.match.params.username}`
                return <div />
            }} />
            <Route path="*" component={NotFound} />
            <Redirect to='/' />
          </Switch>
        </main>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/pages/App.js